const BUZZVIBE_PUBLIC_FALLBACK_ORIGIN = "https://www.buzzvibe.com";
const BUZZVIBE_HOST_PATTERN = /(^|\.)buzzvibe\.com$/i;
const CHURCH_OF_MATRIX_HOST_PATTERN = /(^|\.)churchofmatrix\.(com|org)$/i;

const normalizeHostname = (value = "") => String(value || "").trim().toLowerCase();

export const getCurrentHostname = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return normalizeHostname(window.location.hostname);
};

export const isBuzzVibeHostname = (hostname = "") => BUZZVIBE_HOST_PATTERN.test(normalizeHostname(hostname));

export const isChurchOfMatrixHostname = (hostname = "") => CHURCH_OF_MATRIX_HOST_PATTERN.test(normalizeHostname(hostname));

export const isBuzzVibeVercelHostname = (hostname = "") => {
  const normalizedHostname = normalizeHostname(hostname);

  return (
    /\.vercel\.app$/i.test(normalizedHostname) &&
    /(buzzvibe-frontend|buzz-vibe-frontend)/i.test(normalizedHostname)
  );
};

export const isPublicAppHostname = (hostname = "") => {
  const normalizedHostname = normalizeHostname(hostname);

  return (
    isBuzzVibeHostname(normalizedHostname) ||
    isChurchOfMatrixHostname(normalizedHostname) ||
    isBuzzVibeVercelHostname(normalizedHostname)
  );
};

export const isSocialAppHostname = (hostname = "") => {
  const normalizedHostname = normalizeHostname(hostname);

  return (
    normalizedHostname === "social.buzzvibe.com" ||
    normalizedHostname === "social.churchofmatrix.com" ||
    normalizedHostname === "social.churchofmatrix.org"
  );
};

const resolveCookieDomain = (hostname = "") => {
  const normalizedHostname = normalizeHostname(hostname);

  if (isBuzzVibeHostname(normalizedHostname)) {
    return ".buzzvibe.com";
  }

  if (normalizedHostname === "churchofmatrix.com" || normalizedHostname.endsWith(".churchofmatrix.com")) {
    return ".churchofmatrix.com";
  }

  if (normalizedHostname === "churchofmatrix.org" || normalizedHostname.endsWith(".churchofmatrix.org")) {
    return ".churchofmatrix.org";
  }

  return "";
};

export const getCookieDomainAttribute = (hostname = getCurrentHostname()) => {
  const cookieDomain = resolveCookieDomain(hostname);
  return cookieDomain ? `; Domain=${cookieDomain}` : "";
};

export const getPublicAppOrigin = () => {
  const configuredOrigin = String(process.env.REACT_APP_PUBLIC_APP_URL || "")
    .trim()
    .replace(/\/+$/, "");

  if (typeof window !== "undefined") {
    const currentOrigin = String(window.location.origin || "").replace(/\/+$/, "");

    if (currentOrigin && isPublicAppHostname(window.location.hostname)) {
      return currentOrigin;
    }
  }

  return configuredOrigin || BUZZVIBE_PUBLIC_FALLBACK_ORIGIN;
};

export const buildPublicAppUrl = (path = "/") => {
  const normalizedPath = String(path || "/");
  const resolvedPath = normalizedPath.startsWith("/") ? normalizedPath : `/${normalizedPath}`;

  return `${getPublicAppOrigin()}${resolvedPath}`;
};